<template>
  <footer class="text-gray-700">
    <!-- Top Section -->
    <div class="py-14">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
        <!-- Left Column -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Follow us</h3>

          <!-- Social Icons -->
          <div class="flex items-center space-x-4 mb-6">
            <a href="#" class="hover:text-orange-500 transition">
              <i class="fab fa-facebook text-xl"></i>
            </a>
            <a href="#" class="hover:text-orange-500 transition">
              <i class="fab fa-instagram text-xl"></i>
            </a>
          </div>

          <!-- Contact Info -->
          <div class="space-y-3 text-sm">
            <p class="flex items-center gap-2">
              <span>📞</span>
              <span>NA</span>
            </p>

            <p class="flex items-center gap-2">
              <span>✉️</span>
              <span>contact@iwc.com.ph</span>
            </p>

            <p class="flex items-start gap-2">
              <span>📍</span>
              <span>
                14th Floor Manila Astral Tower Taft Ave. cor Padre Faura Manila, Metro Manila 1000
              </span>
            </p>
          </div>
        </div>

        <!-- Spacer Column (optional center empty space like screenshot) -->
        <div></div>

        <!-- Right Column -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Sitemap</h3>
          <ul class="space-y-3 text-sm">
            <li>
              <a href="https://iwc.com.ph/" target="_blank" class="hover:text-orange-500 transition"
                >Official Website</a
              >
            </li>
            <li>
              <a
                href="https://amap.iwcsrvr.com/"
                target="_blank"
                class="hover:text-orange-500 transition"
                >Automated Member's Availment Portal</a
              >
            </li>
            <li>
              <a
                href="https://telemed.iwc.com.ph/#/"
                target="_blank"
                class="hover:text-orange-500 transition"
                >IMF Teleconsultation</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="border-t border-gray-300">
      <div class="max-w-7xl mx-auto px-6 py-6 flex md:flex-row justify-end items-center text-sm">
        <!-- Left -->

        <!-- Right -->
        <div class="text-gray-500 text-center md:text-right">© 2026 Developed by IWC-InfoTech</div>
      </div>
    </div>
  </footer>
</template>
